var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCmsDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M500.73,231a188.43,188.43,0,0,0-37.13-83.86c-28.36-36.61-65.3-59.93-110.35-70.29-8.58-2-17.45-2.7-26.19-4-1.22-.18-2.42-.51-3.63-.77H308.25c-7.1,2.8-9.44,8.09-9.42,15.58.17,58.06.09,116.12.1,174.18,0,11,4.24,15.26,15.26,15.26,57.92,0,115.83-.08,173.75.11,7.61,0,13.06-2.22,16-9.4v-11C502.92,248.16,502.23,239.48,500.73,231Zm-177.09,21.4V97.49C403.9,101.86,474,169.72,478.52,252.35Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.4,298.94H277.08v-5.66q0-80.55,0-161.09c0-9.06-4.84-14.24-13.75-13.68-12,.77-24.2,1.37-36,3.65C123.48,142.29,55.07,244.59,75.69,348.43c20.73,104.36,122.37,172.49,226.6,151.9,88.83-17.55,154.15-95.82,155.3-186.07C457.73,303.34,453.37,298.94,442.4,298.94Z",
    fill: "#818181"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmsDashboard);
export default __webpack_public_path__ + "static/media/CMS_dashboard.a1adca7b83ebcc92383e08b60f3eca93.svg";
export { ForwardRef as ReactComponent };